import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { usersCountRequest, usersCountRequestError, usersCountRequestSuccess } from "../../slices/Dashboard/usersCountSlice";

export const GetUsersCountAPI = () => async (dispatch) => {
    try {
        dispatch(usersCountRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.usersCount,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(usersCountRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(usersCountRequestError(_error));
            });
    } catch (error) { }
};
